export const environment = {
  apiUrl: 'https://climars-des.pub.hsm.rs.gov.br/climars/api/v1/',
  production: false,
};
